import FilterForm from 'components/forms/FilterForm';
import { DatePicker, Form, FormProps, Input, Select } from 'antd';

export interface IIssuedCertificateFilters {
  by_registration_number: string;
  by_course_code: string;
  by_user_email: string;
  by_user_name: string;
  by_cpf: string;
  issued_after: string;
  issued_before: string;
  registered_after: string;
  registered_before: string;
  by_export_status: string;
}

// "Exportado" e não "impresso": o Atlas gera o arquivo, quem imprime é a secretaria,
// e o sistema não observa a folha saindo da bandeja. Dizer "impresso" na tela seria
// afirmar a quem decide justamente o que não sabemos.
//
// "Todos" é a ausência do filtro: o Select limpo não manda o parâmetro, e a listagem
// segue mostrando os dois juntos. Esconder registro por padrão seria pior do que
// trazer demais.
//
// Rótulo e valor falam línguas diferentes de propósito: o Atlas só sabe que o
// certificado entrou num arquivo baixado (`downloaded`), quem imprime é o operador
// — e é "impresso" a palavra que ele usa. A tradução mora aqui, na borda.
const DOWNLOAD_STATUS_OPTIONS = [
  { label: 'Não exportados', value: 'unexported' },
  { label: 'Já exportados', value: 'exported' }
];

export interface IssuedCertificatesFilterProps {
  searchFormProps: FormProps<IIssuedCertificateFilters>;
}

export const IssuedCertificatesFilter = ({
  searchFormProps
}: IssuedCertificatesFilterProps) => {
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="by_registration_number">
        <Input placeholder="Número de registro" />
      </Form.Item>

      <Form.Item name="by_user_name">
        <Input placeholder="Nome do aluno" />
      </Form.Item>

      <Form.Item name="by_cpf">
        <Input placeholder="CPF" />
      </Form.Item>

      <Form.Item name="by_user_email">
        <Input placeholder="E-mail" />
      </Form.Item>

      <Form.Item name="by_course_code">
        <Input placeholder="Código do curso" />
      </Form.Item>

      <Form.Item name="registered_after">
        <DatePicker
          className="w-full"
          placeholder="Registro a partir de"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="registered_before">
        <DatePicker
          className="w-full"
          placeholder="Registro até"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="issued_after">
        <DatePicker
          className="w-full"
          placeholder="Expedição a partir de"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="issued_before">
        <DatePicker
          className="w-full"
          placeholder="Expedição até"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="by_export_status">
        <Select
          placeholder="Exportação"
          className="lg:w-[200px]"
          options={DOWNLOAD_STATUS_OPTIONS}
          allowClear
        />
      </Form.Item>
    </FilterForm>
  );
};
